import * as angular from 'angular';
import * as _ from 'lodash';
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

let requires = [LoaderServiceName, UIUtilityServiceName];

class TopDefectsGraphCtrl {
  loaderService: LoaderService;
  uiUtilityService: UIUtilityService;

  defects: apsViewModels.TopNDefectReportItem[];
  defectsPretty: any[];
  defectNameToColor: any;

  chartClickWorkaround: any;
  defectSelected: any;

  constructor(uiUtilityService: UIUtilityService) {
    this.uiUtilityService = uiUtilityService;

    this.chartClickWorkaround = {
      barClick: (dimpleEvent) => {
        if (dimpleEvent && dimpleEvent.xValue) {
          var selectedDefect = _.find(this.defects, { defectTypeName: dimpleEvent.xValue, count: dimpleEvent.yValue });
          if (selectedDefect && this.defectSelected) {
            this.defectSelected(selectedDefect);
          }
        }
      }
    };
  }

  setDefects(defects: apsViewModels.TopNDefectReportItem[]): void {
    this.defects = defects;

    this.defectNameToColor = {};
    _.forEach(defects, (d) => {
      var color = this.uiUtilityService.getSeverityColor(d.severity);
      if (color) {
        this.defectNameToColor[d.defectTypeName] = color;
      }
    });

    var unSortedDefectsPretty = _.map(defects, (d) => {
      return {
        'Defect': d.defectTypeName,
        'Count': d.count,
        'Sort Value': (d.count * 100) + (10 - d.severity)
      };
    });
    this.defectsPretty = _.orderBy(unSortedDefectsPretty, ['Count', 'Severity'], ['desc', 'asc']);
  }
}

export default angular.module('aps.controller.topDefectsGraph', requires)
  .controller('TopDefectsGraphCtrl', TopDefectsGraphCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/topDefectsGraph.controller.ts